<template>
    <div v-if="categories.length" class="categorypicker margin-top-20">
        <label>{{ $t('label.categories') }}</label>
        <ul class="categorypicker-list">
            <li v-for="(category, key) in categories" :class="{ 'active': categories[key].active }" @click="toggle(key)">
                <badge :key="category.id"
                       :username="category.name"
                       :backgroundColor="category.color"
                       :useTooltip="false">
                </badge>
                <div class="trim">{{ category.name }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
  import Vue from 'vue'
  import Badge from '@/components/widgets/BadgeWidget'

  export default {
    name: 'CategoryPickerWidget',
    components: {Badge},
    props: ['value'],
    created () {
      this.loadCategories()
    },
    data () {
      return {
        categories: []
      }
    },
    watch: {
      value (value) {
        this.setActiveCategories(value)
      }
    },
    methods: {
      setActiveCategories (newCategories) {
        for (let i in this.categories) {
          let item = this.categories[i]
          item.active = false
          Vue.set(this.categories, i, item)
          if (newCategories) {
            for (let j in newCategories) {
              if (this.categories[i].id === newCategories[j].id) {
                item.active = true
                Vue.set(this.categories, i, item)
              }
            }
          }
        }
      },
      loadCategories () {
        this.$api.get('/v1/categories').then(response => {
          this.categories = response.data.data
        })
      },
      toggle (key) {
        this.categories[key].active = !this.categories[key].active
        this.$emit('input', this.getActiveCategories())
      },
      getActiveCategories () {
        let categories = []
        for (let i in this.categories) {
          let category = this.categories[i]
          if (category.active) {
            categories.push(category)
          }
        }
        return categories
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/widgets/CategoryPickerWidget.vue